// mentionNodeViews.js
// NodeViews for userMention and hashtag inline atoms.
//
// Without a NodeView, ProseMirror renders inline atoms via toDOM which produces
// a <span> with text content. Browsers may select that text on click instead of
// letting ProseMirror create a NodeSelection. Providing a NodeView (like the
// "dino" example on prosemirror.net) gives ProseMirror full ownership of the
// DOM element so clicks reliably produce NodeSelection.

import {AtomicNodeView} from "./AtomicNodeView";

class MentionAtomNodeView extends AtomicNodeView {
    // Keep default behavior: ProseMirror should own selection for inline atoms.
}

export class UserMentionNodeView extends MentionAtomNodeView {
    constructor(node, view, getPos) {
        super(node, view, getPos);

        const span = document.createElement("span");
        span.className = "user-mention";
        span.contentEditable = "false";
        span.setAttribute("spellcheck", "false");
        span.setAttribute("data-mention-id", node.attrs.id);
        span.setAttribute("data-mention-label", node.attrs.label);
        if (node.attrs.name) span.setAttribute("data-mention-name", node.attrs.name);
        if (node.attrs.email) span.setAttribute("data-mention-email", node.attrs.email);
        if (node.attrs.position) span.setAttribute("data-mention-position", node.attrs.position);
        if (node.attrs.headshot) span.setAttribute("data-mention-headshot", node.attrs.headshot);
        span.setAttribute("aria-label", `User mention: ${node.attrs.label || node.attrs.name || "Unknown"}`);
        span.textContent = `@${node.attrs.label}`;

        this.dom = span;
    }
}

export class HashtagNodeView extends MentionAtomNodeView {
    constructor(node, view, getPos) {
        super(node, view, getPos);

        const span = document.createElement("span");
        span.className = "hashtag";
        span.contentEditable = "false";
        span.setAttribute("spellcheck", "false");
        span.setAttribute("data-tag-id", node.attrs.id);
        span.setAttribute("data-tag-label", node.attrs.label);
        if (node.attrs.docId) span.setAttribute("data-tag-doc-id", node.attrs.docId);
        span.setAttribute("aria-label", `Tag: ${node.attrs.label || "Unknown"}`);
        span.textContent = `#${node.attrs.label}`;

        this.dom = span;
    }
}
